import React from 'react'
import { compose, branch, renderNothing } from 'recompose'
import get from 'lodash/get'
import isNil from 'lodash/isNil'
import convert from 'color-convert'

import { DateFormatter, timezoneEnhancer, Status as StatusComponent } from '@infotech/base-components'

import withUserByUserId from '../../hocs/withUserByUserId'


const isBorderNeed = (color) => (
  get(convert.hex.gray(color), `0`) > 90
)

const hintText = `связанной заявки`

const EnhanceDateFormatter = timezoneEnhancer(DateFormatter)

const IssueLinkIdFormatter = ({ issueNumber }) => (
  <div
    title={`Номер ${hintText}`}
    className="issue-link-widget-infoblock__issue-link-id-formatter"
  >
    {issueNumber}
  </div>
)

const IssueLinkIssueType = ({ typeName }) => (
  <div
    title={`Тип ${hintText}`}
    className="issue-link-widget-infoblock__issue-link-issue-type"
  >
    {typeName}
  </div>
)

export const IssueLinkDate = ({ date }) => (
  <div
    title={`Дата создания ${hintText}`}
    className="issue-link-widget-infoblock__createdDate text-right text-muted"
  >
    <EnhanceDateFormatter data={date} />
  </div>
)

const EnhancedDate = ({ date }) => (
  <div className="issue-link-widget-infoblock__end-date">
    <div className="text-muted"> Дата исполнения: </div>
    <EnhanceDateFormatter value={date} />
  </div>
)

export const IssueLinkEndDate = ({ date, showEmptyDate }) => {
  if (showEmptyDate) {
    return (
      <EnhancedDate date={date} />
    )
  }
  if (date) {
    return (
      <EnhancedDate date={date} />
    )
  }
  return null
}

const UserFormatter = compose(
  branch(
    ({ userId }) => isNil(userId),
    renderNothing,
  ),
  withUserByUserId,
)(({
  esuzUser,
}) => (
  <div className="issue-link-widget-infoblock__user-formatter">
    <div className="text-muted">Исполнитель: </div>
    {get(esuzUser, `name`, ``)}
  </div>
))

const StatusFormatter = ({
  status,
}) => (
  <div
    title={`Статус ${hintText}`}
    className="issue-link-widget-infoblock__status-formatter"
  >
    <StatusComponent
      name={get(status, `name`)} color={get(status, `color`)}
      withBorder={isBorderNeed(get(status, `color`))}
    />
  </div>
)

const EsuzIssueLinkInfoblock = ({
  issueLink: {
    status,
    id,
    issueNumber = id,
    createDate,
    userId,
    endDate,
    typeName,
  },
  showEmptyDate = false,
}) => (
  <div className="issue-link-widget-infoblock">
    <div className="issue-link__row">
      <IssueLinkIdFormatter issueNumber={issueNumber} />
      <IssueLinkDate date={createDate} />
    </div>
    <IssueLinkIssueType typeName={typeName} />
    <IssueLinkEndDate showEmptyDate={showEmptyDate} date={endDate} />
    <UserFormatter userId={userId} />
    <div className="issue-link__row">
      <StatusFormatter status={status} />
    </div>
  </div>
)

export default EsuzIssueLinkInfoblock
